import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import API_BASE_URL from "../api";
import "./InfoTemplate.css";
import SEO from './SEO';
import {
    FaWhatsapp,
    FaTelegram,
    FaFacebook,
    FaTwitter,
    FaLinkedin,
    FaShareAlt
} from "react-icons/fa";
import SectionRenderer from "./renderers/SectionRenderer";


function InfoTemplate({ data }) {
    const [showShare, setShowShare] = useState(false);
    if (!data) return <div>Loading...</div>;
    console.table("Data Received:", data);
    console.log(data.sections.vacancy);
    

    const formatDate = (dateString) => {
        if (!dateString) return "N/A";

        const date = new Date(dateString);

        if (isNaN(date.getTime())) return dateString;

        return date.toLocaleDateString("en-GB").replace(/\//g, "-");
    };

    const pageUrl = `https://sarkaricareerinfo.com/info/job/${data.slug}`;
    // const pageUrl = `https://sarkaricareerinfo.com/info/job/${data.id}`;
    const title = data.meta.organization || "Job Notification";
    const last_date = data.meta?.application_last_date ? new Date(data.meta.application_last_date).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
    })
        : "N/A";
    const description = `${data.meta.organization || "The organization"} has released the notification for the ${data.meta.post_name || "various posts"}. \nLast Date : ${last_date || "will be informed soon"}. \nCheck eligibility, vacancy details, age limit all other details in below link`;
    const shareText = `${description}\n\n🔗 ${pageUrl}`;
    if (!data) return <div>Loading...</div>;


    const renderValue = (field) => {
        if (!field?.value) return "—";

        switch (field.type) {
            case "link":
                return (
                    <button
                        onClick={() =>
                            window.open(field.value, "_blank", "noopener,noreferrer")
                        }
                        className="link-button"
                    >
                        Open Link
                    </button>
                );

            case "date":
                return formatDate(field.value);

            default:
                if (
                    typeof field.value === "string" &&
                    /^\d{4}-\d{2}-\d{2}$/.test(field.value)
                ) {
                    return formatDate(field.value);
                }

                return field.value;
        }
    };

    return (
            
        <><SEO
            title={`${data.meta.organization} ${data.meta.post_name} Recruitment 2026`}
            description={`Apply online for ${data.meta.organization} ${data.meta.post_name}. Total Vacancies: ${data.meta.total_vacancies}. Check Eligibility, Salary, Age Limit and Last Date.`}
            keywords={`${data.meta.organization}, ${data.meta.post_name}, Recruitment 2026`}
            url={`https://sarkaricareerinfo.com/info/job/${data.slug}`} />

            <div className="job-container">

                {/* HEADER */}
                <div className="job-header">
                    <h1>{data.title}</h1>
                    <p>{data.organization}</p>


                    <div className="header-top">
                        {/* <div>
        <h1>{data.title}</h1>
        <p>{data.organization}</p>
    </div> */}

                        <div className="share-container">
                            <button
                                className="share-btn"
                                onClick={() => setShowShare(!showShare)}
                            >
                                <FaShareAlt />
                            </button>

                            {showShare && (
                                <div className="share-popup">

                                    <a
                                        href={`https://wa.me/?text=${encodeURIComponent(shareText)}`}
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <FaWhatsapp className="share-icon whatsapp" />
                                    </a>

                                    <a
                                        href={`https://t.me/share/url?url=${encodeURIComponent(pageUrl)}&text=${encodeURIComponent(shareText)}`}
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <FaTelegram className="share-icon telegram" />
                                    </a>

                                    <a
                                        href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(pageUrl)}`}
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <FaFacebook className="share-icon facebook" />
                                    </a>

                                    <a
                                        href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(pageUrl)}&text=${encodeURIComponent(shareText)}`}
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <FaTwitter className="share-icon twitter" />
                                    </a>

                                    <a
                                        href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(pageUrl)}`}
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <FaLinkedin className="share-icon linkedin" />
                                    </a>

                                </div>
                            )}
                        </div>

                    </div>


                </div>

                {/* SECTIONS */}
                {Object.entries(data.sections || {}).map(([key, section]) => (
                    <div className="section-card" key={key}>

                        <h2>{section.title || key}</h2>
                        <SectionRenderer
                            title={key}
                            section={section}
                            renderValue={renderValue}
                        />
                        {/* TABLE TYPE */}
                        {/* {section.type === "table" ? (
                            <table className="table">
                                <tbody>
                                    {Object.entries(section.value || {}).map(([k, v]) => (
                                        <tr key={k}>
                                            <td><b>{k}</b></td>
                                            <td>{v || "—"}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        ) : ( */}
                        {/* {section.type === "table" ? (

                            <table className="table">
                                <tbody>
                                    {Object.entries(section.value || {}).map(([k, v]) => (
                                        <tr key={k}>
                                            <td><b>{k}</b></td>
                                            <td>{v || "—"}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                        ) : section.type === "posts_qualification" ? (

                            <table className="table">
                                <tbody>

                                    <tr>
                                        <td><b>Total Posts</b></td>
                                        <td>{section.value?.total_posts || "—"}</td>
                                    </tr>

                                    <tr>
                                        <td><b>Qualifications</b></td>

                                        <td>

                                            <table className="inner-table">

                                                <thead>
                                                    <tr>
                                                        <th>Post</th>
                                                        <th>Qualification</th>
                                                    </tr>
                                                </thead>

                                                <tbody>

                                                    {(section.value?.rows || []).map((row, index) => (

                                                        <tr key={index}>
                                                            <td>{row.post}</td>
                                                            <td>{row.qualification}</td>
                                                        </tr>

                                                    ))}

                                                </tbody>

                                            </table>

                                        </td>

                                    </tr>

                                </tbody>
                            </table>

                        ) : (
                            <div className="section-body">
                                {Object.entries(section.fields || {}).map(([k, field]) => (
                                    <div className="section-row" key={k}>
                                        <span className="section-label">
                                            {field.label}
                                        </span>
                                        <span className="section-value">
                                            {renderValue(field)}
                                        </span>
                                    </div>
                                ))}
                            </div>
                        )} */}



                    </div>
                ))}

            </div></>
    );
}

export default InfoTemplate;
